/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Tricks webpack to expose the runtime process instead of stringifying it
 */

// NOTE: webpack will replace all instances of process.env with a static object at compile time.
// Here we are circumventing that behavior using a trick to side-step that replacement. This
// gives us access to runtime environment variables, which we need to passing settings from the
// env, such as REDIS_SESSION_URL
// https://webpack.js.org/plugins/define-plugin/
// https://stackoverflow.com/a/49896877

let processEnv = {}

try {
  processEnv = typeof process !== 'undefined' ? process['en'.concat('v')] : {}
} catch (e) {
  processEnv = {}
}

export { processEnv }
